import * as React from "react";

const SvgComponent = ({ fill = "var(--filter-bar-btn-border)", stroke = "var(--filter-bar-btn-border)", ...props }) => (
  <svg
    width={30}
    height={30}
    fill={props.color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} y={0.5} width={29} height={29} rx={5.5} stroke={stroke} />
    <path
      d="M14.851 9.227a4.192 4.192 0 0 0-.954 4.454l-5.64 5.64L8 21.756l3.218-.55.134-1.481 1.48-.135.135-1.48 1.48-.135 1.873-1.872a4.192 4.192 0 0 0 4.453-.955 4.187 4.187 0 1 0-5.921-5.922Zm3.096 1.211a1.142 1.142 0 1 1 1.615 1.615 1.142 1.142 0 0 1-1.615-1.615Z"
      fill={fill}
    />
  </svg>
);

export default SvgComponent;